import { useURLSearchParams } from 'hooks/useURLSearchParams';
import { useOn3DSStatusUpdates } from './threeds2.hooks';
import ThreeDS2CheckoutSdk from 'pages/payments/threeds2-checkout-sdk/threeds2-checkout-sdk.component';

// This is the native-app-only /payments/threeds2verification route — the
// mobile WebView reads transactionToken/environmentKey from the URL instead
// of being passed props (there's no React parent on the native side), and
// useOn3DSStatusUpdates forwards the status event to the app via
// fireListeners instead of the web modal's redirect-and-close behavior.
// Same ThreeDS2CheckoutSdk rendering/lifecycle wiring as the web modal
// (docs §7 — the new SDK's six callbacks share the legacy 3ds:status event's
// six-action vocabulary, so this hook needs no changes to work against them).
const ThreeDS2 = () => {
  const searchParams = useURLSearchParams();
  const onStatusUpdate = useOn3DSStatusUpdates();

  return (
    <ThreeDS2CheckoutSdk
      environmentKey={searchParams.get('environmentkey')}
      transactionToken={searchParams.get('token')}
      onStatusUpdate={onStatusUpdate}
    />
  );
};

export default ThreeDS2;
